module.exports = __webpack_public_path__ + "img/trash-red.04b7745a.svg";